import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import PlannerModuleForm from '../containers/PlannerModuleFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class PlannerModuleAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `PlannerModuleAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('planner_module_route_add')} />
          <PlannerModuleForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default PlannerModuleAddScreen;

Logger.log('silly', `PlannerModuleAddScreen loaded.`);
